export default "__VITE_ASSET__C9Bdq05$__"